import calendarApi from './calendarApi'

const STATUS = {
  pending: 'pending',
  success: 'success',
  error: 'error'
}
Object.freeze(STATUS)

export default {
  async fetchEvents ({ commit }, {
    year,
    month
  }) {
    commit('SET_STATUS', {
      month,
      year,
      status: STATUS.pending
    })

    await calendarApi.get('/event', {
      params: {
        year,
        month
      }
    })
      .then((response) => {
        commit('SET_EVENTS', {
          month,
          year,
          events: response.data.data
        })
        commit('SET_STATUS', {
          month,
          year,
          status: STATUS.success
        })
      })
      .catch(() => {
        commit('SET_STATUS', {
          month,
          year,
          status: STATUS.error
        })
      })
  },
  async fetchCalendars ({ commit }) {
    commit('SET_CALENDAR_STATUS', STATUS.pending)

    await calendarApi.get('/calendar')
      .then((response) => {
        commit('SET_CALENDARS', response.data.data)
        commit('SET_CALENDAR_STATUS', STATUS.success)
      })
      .catch(() => {
        commit('SET_CALENDAR_STATUS', STATUS.error)
      })
  }
}
